/**
 * Pure path helpers for the project-local plugin store.
 *
 * The store is a self-contained npm workspace owned by the CLI under
 * `<projectDir>/.skaile/plugins/`. Nothing here touches the filesystem.
 */

import { join } from "node:path";

/** `<projectDir>/.skaile/plugins` — the store root. */
export function pluginsDir(projectDir: string): string {
  return join(projectDir, ".skaile", "plugins");
}

/** `<store>/package.json` — generated, never user-edited. */
export function pluginsPkgJson(projectDir: string): string {
  return join(pluginsDir(projectDir), "package.json");
}

/** `<store>/node_modules` — where reconciled plugin packages land. */
export function nodeModulesDir(projectDir: string): string {
  return join(pluginsDir(projectDir), "node_modules");
}

/** `<store>/.reconcile-hash` — SHA of plugins-list + lock slice; skip reinstall when unchanged. */
export function reconcileHashFile(projectDir: string): string {
  return join(pluginsDir(projectDir), ".reconcile-hash");
}

/**
 * Absolute path to a plugin package's entry directory under the store's
 * `node_modules`. Dynamic `import()` against this absolute path works inside
 * compiled binaries via `pathToFileURL`.
 */
export function resolvePluginEntry(projectDir: string, pkgName: string): string {
  return join(nodeModulesDir(projectDir), pkgName);
}
